module.exports = __webpack_public_path__ + "static/media/footer_search_black.32477c59.png";